let MOBILE_BREAKPOINT = '(max-width: 767px)';
let isMobile = window.matchMedia(MOBILE_BREAKPOINT);

const SCROLL_DURATION = 200;

function smoothScrollTo(scroller, startY, targetY, duration) {
    const diff = targetY - startY;
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;
        scroller.scrollTo(0, startY + diff * ease);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

document.querySelectorAll('.c24FaqAccordion').forEach((accordion) => {
    if (isMobile.matches && accordion.classList.contains('mobile-fixed-open')) {
        return;
    }

    const items = accordion.querySelectorAll('.c24FaqAccordion__item');

    items.forEach((item) => {
        const question = item.querySelector('.c24FaqAccordion__question');
        const answer = item.querySelector('.c24FaqAccordion__answer');
        const inner = item.querySelector('.c24FaqAccordion__answer-inner');

        answer.style.transition = 'none';
        answer.style.height = '0';
        answer.offsetHeight;
        answer.style.transition = '';

        question.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            items.forEach((other) => {
                if (other !== item && other.classList.contains('is-open')) {
                    const otherAnswer = other.querySelector('.c24FaqAccordion__answer');
                    other.classList.remove('is-open');
                    otherAnswer.style.height = otherAnswer.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        otherAnswer.style.height = '0';
                    });
                }
            });

            if (isOpen) {
                answer.style.height = answer.scrollHeight + 'px';
                requestAnimationFrame(() => {
                    answer.style.height = '0';
                });
                item.classList.remove('is-open');
            } else {
                item.classList.add('is-open');
                answer.style.height = inner.offsetHeight + 'px';
                answer.addEventListener('transitionend', function handler(e) {
                    if (e.propertyName !== 'height') return;
                    answer.style.height = 'auto';
                    answer.removeEventListener('transitionend', handler);
                }, { once: true });
                setTimeout(() => {
                    const scroller = document.scrollingElement || document.documentElement;
                    const questionTop = question.getBoundingClientRect().top;
                    if (questionTop < 0) {
                        const startY = scroller.scrollTop;
                        smoothScrollTo(scroller, startY, startY + questionTop, 400);
                    }
                }, 150);
            }
        });
    });
});
